import { LOAD_USER_ORDERS } from '../actions/type'

const myOrders = {
    loading: true,
    orders: {},
    liveOrders: [],
    pastOrders: []
}

export default (state = myOrders, action) => {
    switch (action.type) {
        case LOAD_USER_ORDERS:
            return {
                loading: false,
                orders: action.payload.orders,
                liveOrders: action.payload.liveOrders,
                pastOrders: action.payload.pastOrders
            }
        default:
            return state
    }
}